import React from "react";

const StatusChip = ({ status }) => {
  const label = status ? "Active" : "Inactive";
  const className = status
    ? "block text-center w-[85px] py-1 rounded-md text-sm font-semibold uppercase tracking-wide bg-green-100 text-green-700"
    : "block text-center w-[85px] py-1 rounded-md text-sm font-semibold uppercase tracking-wide bg-gray-100 text-gray-500 border border-gray-300";
  return <span className={className}>{label}</span>;
};

export default StatusChip;
